export const TOKEN_VALUE = 20;